// extracted by css-extract-rspack-plugin
export default {"resizing":"CDs34","column":"tLxOO","footer":"I73JY","preview":"raFA6"};